import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './AllStaffStatus.css'; // Import custom CSS for additional styling
import SidebarMenu from "../Widgets/SideBar Menu/SidebarMenu";
import { get_aqato_listing_data_api } from "../../api";

const AllStaffStatus = () => {
    const [staff, setStaff] = useState([
        // { name: "John Doe", email: "john.doe@example.com", status: "online" },
        // { name: "Jane Smith", email: "jane.smith@example.com", status: "lunch" },
        // { name: "Alice Johnson", email: "alice.johnson@example.com", status: "offline" },
        // Add more staff members as needed
    ]);

    const [searchTerm, setSearchTerm] = useState("");

    const getStatusIcon = (status) => {
        switch (status) {
            case "online":
                return <i className="bi bi-circle-fill text-success"></i>;
            case "lunch":
                return <i className="bi bi-circle-fill text-warning"></i>;
            case "offline":
                return <i className="bi bi-circle-fill text-secondary"></i>;
            default:
                return null;
        }
    };

    // Filter staff based on the search term
    const filteredStaff = staff.filter(member =>
        member.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        member.email.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const pre_get_aqato_listing_data_api = async () => {
        try {

            const response = await get_aqato_listing_data_api();

            console.log("response?.data?.response?.response", response?.data?.response?.response);

            if (
                response &&
                response?.data &&
                response?.data?.response &&
                response?.data?.response?.response === true
            ) {
                console.log(response?.data?.response?.data?.staffs);
                setStaff(response?.data?.response?.data?.staffs);

            } else {

                console.error(
                    "Error",
                    response?.data?.error_msg || "Unknown error"
                );

            }
        } catch (error) {

            console.error("Error", error);
        }
    }

    useEffect(() => {
        pre_get_aqato_listing_data_api();
    },[]);

    return (
        <>
            <div className="main_desktop">
                <div className="main-wrapper">
                    <div className="sub-wrapper-sidebar mt-1">
                        <SidebarMenu />
                    </div>
                    <div className="sub-wrapper-main">
                        <div className="main-heading-title">
                            <h3 className="heading-admin-title text-color-green mt-1">
                                Staff Status
                            </h3>
                        </div>
                        <div className="mb-1">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search by name or email"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <div className="table-responsive mt-1">
                            <table className="table all_member_table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredStaff.length > 0 ? (
                                        filteredStaff.map((member, index) => (
                                            <tr key={index}>
                                                <td>{member.name}</td>
                                                <td>{member.email}</td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        {getStatusIcon(member.status)}
                                                        <span className="ms-2">{member.status.charAt(0).toUpperCase() + member.status.slice(1)}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="3" className="text-center">No results found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AllStaffStatus;